export default __webpack_public_path__ + "static/media/119-brunei.79631dd7.svg";